import { render, staticRenderFns } from "./Methodology.vue?vue&type=template&id=29ee235c"
import script from "./Methodology.vue?vue&type=script&lang=js"
export * from "./Methodology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports